var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShutters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03614 8.25V20C3.03614 20.5523 3.48386 21 4.03614 21H5.62644C6.17873 21 6.62644 20.5523 6.62644 20V15M3.03614 8.25H20.9639M3.03614 8.25H2.86871C2.4585 8.25 2.18277 7.8295 2.34629 7.4533V7.4533C3.52164 4.74918 6.18921 3 9.13771 3H14.1294C17.1671 3 19.9686 4.6385 21.4578 7.28613L21.492 7.34691C21.7193 7.75087 21.4273 8.25 20.9639 8.25V8.25M20.9639 8.25V20C20.9639 20.5523 20.5161 21 19.9639 21H18.5964C18.0441 21 17.5964 20.5523 17.5964 20V15M9.20361 5.75H14.5M6.62644 15V12.25C6.62644 11.6977 7.07416 11.25 7.62644 11.25H16.5964C17.1487 11.25 17.5964 11.6977 17.5964 12.25V15M6.62644 15H10.1879M17.5964 15H14.1253M10.1879 15V15C11.0514 13.4648 13.2617 13.4648 14.1253 15V15M10.1879 15H14.1253",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutters);
export default __webpack_public_path__ + "static/media/shutters.fe2803d54aad25d2f04b72c3dd81637d.svg";
export { ForwardRef as ReactComponent };